import { LockableField } from '@/components/table/table-types';
import { SelectableMenuItem } from '@/components/table/toolbar/selectable-menu-item';
import { themeColors } from '@/theme/colors';
import { Button, Icon, Menu } from '@lego/connect-components-react';
import { useRef, useState } from 'react';

type LockDropdownProps = {
  disabled?: boolean;
  onChange: (selectedVal: LockableField) => void;
  value?: LockableField | undefined;
};

const LOCK_OPTIONS: { label: string; value: LockableField | '' }[] = [
  { label: 'None', value: '' },
  { label: 'RRP', value: LockableField.rrp },
  { label: 'LP', value: LockableField.lp },
  { label: 'RM%', value: LockableField.rm },
];

const LockDropdown = ({
  disabled = false,
  onChange,
  value,
}: LockDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const isLocked = !!value;
  const selectedLabel =
    LOCK_OPTIONS.find((opt) => opt.value === (value ?? ''))?.label ?? 'None';

  return (
    <>
      <Button
        ref={anchorRef}
        disabled={disabled}
        appearance="ghost"
        size="small"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Lock/Unlock"
        iconName="chevron-down-solid"
        iconPosition="end"
        style={{ color: themeColors.content.default, gap: '4px' }}
      >
        <Icon
          name={isLocked ? 'lock-solid' : 'lock-open-solid'}
          aria-label={isLocked ? 'Locked' : 'Unlocked'}
          size="small"
          isChild
        />
        <span style={{ marginLeft: '4px' }}>{selectedLabel}</span>
      </Button>
      <Menu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        anchorRef={anchorRef}
        aria-labelledby="lock-unlock-menu"
        offset={4}
        style={{ minWidth: '120px' }}
      >
        {LOCK_OPTIONS.map((option) => (
          <SelectableMenuItem
            key={option.label}
            value={option.value}
            label={option.label}
            isSelected={(value ?? '') === option.value}
            onClick={() => {
              onChange(option.value as LockableField);
              setIsOpen(false);
            }}
          />
        ))}
      </Menu>
    </>
  );
};
export default LockDropdown;
